import React, { useState, useMemo } from 'react';
import { Edit, Trash, CirclePlus } from 'tabler-icons-react';
import { useCalidad, CAT_CAUSAS } from './CalidadContext';
import SearchInput from '../../components/SearchInput';
import ItemModal from './ItemModal';
import ConfirmModal from '../../components/ConfirmModal';
import filtrarItems from './filtrarItems';

export default function CausasRaiz() {
    const { causas, loading, postItem, putItem, deleteItem, errorMsg, setErrorMsg } = useCalidad();

    const [busqueda, setBusqueda] = useState('');
    const [modalItem, setModalItem] = useState(null); // { item: null } = alta
    const [porEliminar, setPorEliminar] = useState(null);

    const visibles = useMemo(() => filtrarItems(causas, busqueda), [causas, busqueda]);

    const abrirModal = (item) => {
        setErrorMsg(null);
        setModalItem({ item });
    };

    const cerrarModal = () => {
        setModalItem(null);
        setErrorMsg(null);
    };

    const guardar = async (nombre) => {
        const ok = modalItem.item
            ? await putItem(CAT_CAUSAS, modalItem.item.codigo, nombre)
            : await postItem(CAT_CAUSAS, nombre);
        if (ok) cerrarModal();
    };

    return (
        <div className="cap-card">
            <div className="cap-card-toolbar">
                <h3 className="cap-card-title">Causas raíz</h3>
                <SearchInput value={busqueda} onChange={setBusqueda} />
            </div>

            <div className="cap-fields-grid">
                {loading && causas.length === 0 && <p className="desc">Cargando...</p>}
                {!loading && causas.length > 0 && visibles.length === 0 && (
                    <p className="desc">Sin resultados para «{busqueda}»</p>
                )}
                {visibles.map((item) => (
                    <div key={item.id} className="cap-catalog-card">
                        <span className="cap-catalog-card-code">{item.codigo}</span>
                        <span className="cap-catalog-card-name">{item.nombre}</span>
                        <div className="cap-catalog-card-actions">
                            <button className="cap-catalog-btn" onClick={() => abrirModal(item)}>
                                <Edit size={16} />
                            </button>
                            <button
                                className="cap-catalog-btn cap-catalog-btn--delete"
                                onClick={() => setPorEliminar(item)}
                            >
                                <Trash size={16} />
                            </button>
                        </div>
                    </div>
                ))}
                <button className="cap-catalog-add" onClick={() => abrirModal(null)}>
                    <CirclePlus size={24} />
                    <span>Agregar</span>
                </button>
            </div>

            <ItemModal
                open={!!modalItem}
                onClose={cerrarModal}
                onSubmit={guardar}
                titulo={`${modalItem?.item ? 'Editar' : 'Nueva'} — Causa raíz`}
                item={modalItem?.item || null}
                errorMsg={errorMsg}
            />

            <ConfirmModal
                open={!!porEliminar}
                onClose={() => setPorEliminar(null)}
                onConfirm={async () => {
                    await deleteItem(CAT_CAUSAS, porEliminar.codigo);
                    setPorEliminar(null);
                }}
                title="Eliminar — Causa raíz"
            >
                ¿Estás seguro de eliminar <strong>{porEliminar?.nombre}</strong>? Esta acción no se
                puede deshacer.
            </ConfirmModal>
        </div>
    );
}
